'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @fileOverview
 * @author Donny
 */
/**
 * 提供一个能够判断当前环境的工具库
 * 请提供三个入参daily, pre, prod作为判断环境的方式
 * 入参可以为string或function
 * 当为string时，会匹配域名
 * 当为function时会调用函数，函数返回值为true时代表环境判断结果为真
 */
var webpack = exports.webpack = function webpack(env) {
  // param check
  if (!env) {
    throw new Error('param error, token: ' + token + ', env: ' + env + ', prefix: ' + prefix);
  }
  if (typeof env.isNotDev !== "function") {
    throw new Error('env object error');
  }

  return {
    setPublicPath: function setPublicPath(publicPath) {
      if (env.isNotDev()) {
        if (!publicPath) {
          throw new Error('assets public path need assigned');
        } else {
          __webpack_public_path__ = publicPath;
        }
      } else if (publicPath) {
        __webpack_public_path__ = publicPath;
      }
    }
  };
};

exports.default = webpack;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_alipic-utils@0.0.2@@ali/alipic-utils/lib/webpackEnv.js
// module id = 268
// module chunks = 6